import { render, staticRenderFns } from "./repairtaskdeviceconsumable.vue?vue&type=template&id=0fa1fffa&"
import script from "./repairtaskdeviceconsumable.vue?vue&type=script&lang=js&"
export * from "./repairtaskdeviceconsumable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports